/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown>, from: NonNullable<unknown> }} Workout_Swap_Scope_Plan_NoteInputs */

const en_us2_workout_swap_scope_plan_note = /** @type {(inputs: Workout_Swap_Scope_Plan_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} takes the place of ${i?.from} in your next workouts`)
};

const pt_br2_workout_swap_scope_plan_note = /** @type {(inputs: Workout_Swap_Scope_Plan_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} entra no lugar de ${i?.from} nos próximos treinos`)
};

const es_419_workout_swap_scope_plan_note = /** @type {(inputs: Workout_Swap_Scope_Plan_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} toma el lugar de ${i?.from} en tus próximos entrenamientos`)
};

const pt_pt2_workout_swap_scope_plan_note = /** @type {(inputs: Workout_Swap_Scope_Plan_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} fica no lugar de ${i?.from} nos próximos treinos`)
};

const fr_fr2_workout_swap_scope_plan_note = /** @type {(inputs: Workout_Swap_Scope_Plan_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} remplace ${i?.from} dans tes prochaines séances`)
};

const de_de2_workout_swap_scope_plan_note = /** @type {(inputs: Workout_Swap_Scope_Plan_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} ersetzt ${i?.from} in deinen nächsten Trainings`)
};

const it_it2_workout_swap_scope_plan_note = /** @type {(inputs: Workout_Swap_Scope_Plan_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} prende il posto di ${i?.from} nei prossimi allenamenti`)
};

/**
* | output |
* | --- |
* | "{name} takes the place of {from} in your next workouts" |
*
* @param {Workout_Swap_Scope_Plan_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_scope_plan_note = /** @type {((inputs: Workout_Swap_Scope_Plan_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Scope_Plan_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_scope_plan_note(inputs)
	if (locale === "es-419") return es_419_workout_swap_scope_plan_note(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_scope_plan_note(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_scope_plan_note(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_scope_plan_note(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_scope_plan_note(inputs)
	return en_us2_workout_swap_scope_plan_note(inputs)
});
export { workout_swap_scope_plan_note as "workout-swap.scope_plan_note" }